import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState} from 'react';
import Grid from '@mui/material/Grid';
import { createSearchParams, useLocation } from "react-router-dom";
import { store } from '../helpers/store';
import { setPageLoadFinish, setPageLoading } from '../slices/page.slice';
import { fetchReturnedInvoices, invoiceItemsSelector, setInvoiceLoading, setReturnedInvoiceSearchKeyDeliverylocationumber, setReturnedInvoiceSearchKeyFromdate, setReturnedInvoicesearchKeySaletype, setReturnedInvoiceSearchKeyTodate, setReturnedInvoiceSearchKeyNumber, setReturnedInvoiceSearchKey, clearInvoiceFilters, fetchInvoice, setSelectedInvoiceId, setSelectedReturnedInvoiceId, clearReturnedInvoiceFilters } from "../slices/returnedInvoices.slice";
import DataGrid from 'react-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Checkbox from '@mui/material/Checkbox';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { pink } from '@mui/material/colors';
import SvgIcon from '@mui/material/SvgIcon';
import DehazeIcon from '@mui/icons-material/Dehaze';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TextField from '@mui/material/TextField';
import DatePicker from "react-multi-date-picker"
import { Calendar } from "react-multi-date-picker"
import moment from 'jalali-moment'
import Tooltip from '@mui/material/Tooltip';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import JalaliUtils from "@date-io/jalaali";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Modal from "@material-ui/core/Modal";
import { useNavigate } from "react-router-dom";


export const zeroPad = (num, places) => String(num).padStart(places, '0');




export const ReturnedInvoices = () => {
  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);
  const authUser = JSON.parse(localStorage.getItem('user'));

  const returnedInvoices = useSelector(x => x.returnedInvoices);
  const defaultValues1 = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));

  let navigate = useNavigate();
 


const columns = [
  //{
    //key: "ID",
    //name: '',
    //resizable: false,
    //sortable: false,
    //frozen: false,
    //headerRenderer(props) {
    //  return ( "");
    //},
    //formatter(props) {
    //  return  <Checkbox  onChange={(e) => handleChange(e,'unitTitle', props,props.row.UnitTitle)}/>;
    //},
    //groupFormatter(props) {
    //  return  <Checkbox/>;
    //},
    //width: '2%'
  //},
  {
    name: 'ردیف',
    key: 'rowIndex',
    width: '1%',
  }, 
  {
    key: 'Number',
    name: 'شماره',
    width: '12%',
    resizable: true,
    sortable: true,
    formatter(props) {
      //console.log(props.row);
      return <Link component="button"variant="body2" onClick={(e) => handleChange(e,'number', props, props.row.ID)}>{props.row.Number}#</Link>
    }
  },
  {
    key: 'CustomerDLTitle',
    name: 'عنوان مشتری',
    width: '20%',
    resizable: true,
    sortable: true
  },
  {
    key: 'CustomerDLCode',
    name: 'کد مشتری',
    width: '11%',
    resizable: true,
    sortable: true
  },
  {
    key: 'CustomerRealName',
    name: 'عنوان فاکتور',
    width: '10%',
    resizable: true,
    sortable: true
   },
  //{
  //  key: 'DeliveryLocationTitle',
  //  name: 'محل تحویل',
  //  width: '10%',
  //  resizable: true,
  //  sortable: true
  //},
  //{
  //  key: 'SaleTypeTitle',
  //  name: 'نوع فروش',
  //  width: '10%',
  //  resizable: true,
  //  sortable: true
  //},
  {
    key: 'Date',
    name: 'تاریخ',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'Price_sh',
    name: 'کل',
    type: 'number',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'Discount_sh',
    name: 'تخفیف',
    type: 'number',
    width: '10%',
    resizable: true,
    sortable: true
  },
  {
    key: 'NetPrice_sh',
    name: 'خالص',
    type: 'number',
    width: '11%',
    resizable: true,
    sortable: true
  }
];


   useEffect(() => {
      //console.log("useEffect"); 
      //console.log("currentPageIndex"); 
      //console.log(ReturnedInvoices.currentPageIndex); 
      
      //dispatch(setLoading());
      if(returnedInvoices.fetchPermission){
        dispatch(fetchReturnedInvoices({hasMore: true, pageindex: 0 , searchkey : returnedInvoices.searchKey, fromdate: (returnedInvoices.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : returnedInvoices.searchKey_fromdate), todate : (returnedInvoices.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : returnedInvoices.searchKey_todate ), authUser}));

      }

   }, []);


   const handleChange = (e , changingItemType, props , value) => {
  
    //console.log(e.target);
    //console.log(props.row);//SelectedRow
    //console.log("Handle Checkbx change");
    switch(changingItemType) {
      case 'unitTitle':
        // code block
        //console.log(props.row.Number);
        break;
      case 'number':
        console.log("Value is "+ value);
   
        navigate('/returnedinvoice');
        
        dispatch(setSelectedReturnedInvoiceId(value));

        //این اوکیه
        //navigate({ pathname : '/invoice' , search : createSearchParams({
        //    entityId : value
        //}).toString()});
      
       
       
        break;
      default:
        // code block
    }
  
  }
  
  function rowKeyGetter(row) {
    return row.ID;
  }

  
   async function handleScroll(event) {
    if (returnedInvoices.loading || !isAtBottom(event)) return;


    await loadMoreRows();

    //setRows([...rows, ...newRows]);
    //setIsLoading(false);
  }
  function EmptyRowsRenderer() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {returnedInvoices.loading ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  function isAtBottom({ currentTarget }) {
    if(currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight){
        //console.log("isAtBottom");
        
    }
    return currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight;
  }
  
  function loadMoreRows() {
    //console.log("currentPageIndex for load more"); 
    ///dispatch(setLoading());
    dispatch(fetchReturnedInvoices({hasMore: returnedInvoices.hasMore, pageindex: returnedInvoices.currentPageIndex , searchkey : returnedInvoices.searchKey, fromdate: (returnedInvoices.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : returnedInvoices.searchKey_fromdate), todate : (returnedInvoices.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : returnedInvoices.searchKey_todate ), authUser}));
  }

  
   let dataSource  = [];

   if(returnedInvoices.items !== undefined && returnedInvoices.items.length > 0)
   {
       dataSource = returnedInvoices.items.map((item, i) => ({...item, rowIndex : i+1}));
   }
   const dynamicHeight = Math.min(returnedInvoices.items.length * 6 + 20, 75) + 'vh';

   const mdTheme = createTheme({
    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
  });

const onSearchHandler = (e) =>{

  dispatch(fetchReturnedInvoices({hasMore: true, pageindex: 0 , searchkey : returnedInvoices.searchKey, searchkey : returnedInvoices.searchKey, fromdate: (returnedInvoices.searchKey_fromdate === '' ? defaultValues.FiscalYearStartDate : returnedInvoices.searchKey_fromdate), todate : (returnedInvoices.searchKey_todate === '' ?defaultValues.FiscalYearEndDate : returnedInvoices.searchKey_todate ), authUser}));

}

const onClearFilterHandler = (e) =>{

  dispatch(clearReturnedInvoiceFilters());

}

const onSearchChange = (e) =>{

  dispatch(setReturnedInvoiceSearchKey(e.target.value));
}

const onFromDateSelectedHandler = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;

  dispatch(setReturnedInvoiceSearchKeyFromdate(year + "/" + month + "/"+ day));
  
}
const onToDateSelectedHandler = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;
  dispatch(setReturnedInvoiceSearchKeyTodate(year + "/" + month + "/"+ day));
}

  return (
    <>

<ThemeProvider theme={mdTheme}>

   <Box sx={{ flexGrow: 1 }}>
     
   <Grid container>
            <Grid item xs={12}>
                     
                      <Accordion>
              <AccordionSummary
                expandIcon={<FilterAltIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
               <Typography sx={{ width: '33%', flexShrink: 0 }}>
            فهرست فاکتور های برگشتی من
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>برای جستجو کلیک کنید</Typography>
              </AccordionSummary>
              <AccordionDetails>
              <span className='fontSize14'>
                  جستجو:
              </span>
                <TextField value={ReturnedInvoices.searchKey} size="small" label="عبارت جستجو" variant="outlined" onChange={onSearchChange} />
                
                <span className='fontSize14'>
                  از:
              </span>
                <DatePicker value={ReturnedInvoices.searchKey_fromdate}
                            onChange={onFromDateSelectedHandler}
                            calendar={persian}
                            locale={persian_fa}
                            animation="true"
                            inputClass="dateCss" style = {{width: 100}}
                          />
                 <span className='fontSize14'>
                  تا:
              </span>
                <DatePicker value={ReturnedInvoices.searchKey_todate}
                            onChange={onToDateSelectedHandler}
                            calendar={persian}
                            locale={persian_fa}
                            animation="true"
                            inputClass="dateCss" style = {{width: 100}}
                          />
                          <Tooltip arrow followCursor title="جستجو">
                          <IconButton onClick={onSearchHandler}>
                  <SearchIcon sx={{ color: '#2979FF' }}/>
                </IconButton>
              </Tooltip>
              <Tooltip arrow followCursor title="حذف فیلترها">
                                        <IconButton onClick={onClearFilterHandler}>
                                <FilterAltOffIcon sx={{ color: '#F44336' }}/>
                              </IconButton>
              </Tooltip>
              </AccordionDetails>
        </Accordion>
           </Grid>
   </Grid>
   </Box>
  <DataGrid 
    //className='headerWithFilterGrid'
    renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
    direction="rtl" 
    columns={columns} 
    rows={dataSource} 
    rowKeyGetter={rowKeyGetter}
    onScroll={handleScroll}
    //headerRowHeight={100}
    style={{height : dynamicHeight}}
    />

    

    {returnedInvoices.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }

    </ThemeProvider>
    </>
  );
}

export default ReturnedInvoices;